module.exports = __webpack_public_path__ + "img/Reject.0d1f3047.svg";